export const APP_TYPES = {
  REX_CRM: "Rex CRM",
  REX_PM: "Rex PM",
};
